import Select, { components } from 'react-select'

import Icon from './Icon'
import React from 'react'

const indicatorSeparatorStyle = {
  backgroundColor: '#CCCCCC',
}

const styles = {
  control: (styles, { data, isDisabled, isFocused, isSelected }) => {
    return {
      ...styles,
      'border': isFocused ? 0 : 0,
      'boxShadow': isFocused ? 0 : 0,
      'outline': isFocused ? '2px solid #000' : 0,
      '&:hover': {
        border: isFocused ? 0 : 0,
      },
    }
  },
  option: (styles, { data, isDisabled, isFocused, isSelected }) => {
    return {
      ...styles,
      cursor: 'pointer',
      backgroundColor: isSelected ? '#f5f5f5' : 'white',
      color: '#3a3a3a',
      // opacity: isDisabled ? '0.7' : '1'
    }
  },
}

const IndicatorSeparator = ({ innerProps }) => {
  return <span style={indicatorSeparatorStyle} {...innerProps} />
}

const DropdownIndicator = (props) => {
  return (
    <components.DropdownIndicator {...props}>
      <Icon id="dropdown-arrow" />
    </components.DropdownIndicator>
  )
}

const DropdownAlgolia = React.memo((props) => {
  const classes = props.classes ? props.classes : ''

  return (
    <Select
      className={`dropdown-algolia ${classes}`}
      classNamePrefix="dropdown-algolia"
      closeMenuOnSelect
      isClearable={false}
      isSearchable={false}
      isDisabled={props.isDisabled || false}
      instanceId={props.instanceId}
      inputId={props.inputId}
      aria-label={props.ariaLabel}
      aria-labelledby={props.ariaLabelledby}
      name={props.instanceId}
      placeholder={props.placeholder}
      components={{ IndicatorSeparator, DropdownIndicator }}
      onChange={props.onChange}
      options={props.options}
      value={props.options.find((option) => option.selected)}
      styles={styles}
    />
  )
})

export default DropdownAlgolia
